import addOutSystemPage from './views/outSystemInfo.html'
import outSystemListPage from './views/outSystemList.html'

export const SysRouter = {
    state: 'system.syssetting.outSystem',
    config: {
        abstract: true,
        url: '/outSystem',
        template: '<div ui-view></div>',
        // controller: 'outSystemCtrl',
        title: '外部系统',
        default: 'system.syssetting.outSystem.list',
    },
}

export const addRouter = {
    state: 'system.syssetting.outSystem.add',
    config: {
        url: '/add',
        template: addOutSystemPage,
        controller: 'outSystemInfoCtrl',
        title: '新增',
    },
}

export const editRouter = {
    state: 'system.syssetting.outSystem.edit',
    config: {
        url: '/edit',
        template: addOutSystemPage,
        controller: 'outSystemInfoCtrl',
        title: '编辑',
    },
}

export const infoRouter = {
    state: 'system.syssetting.outSystem.list',
    config: {
        url: '/list',
        template: outSystemListPage,
        controller: 'outSystemListCtrl',
    },
}



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/outsystem/Routers.js